import { Routes } from '@angular/router';
import { provideAlerting } from '@zero/alerting/domain';
import { provideSelfServiceDomain } from '@zero/self-service/domain';

export const USER_SELF_SERVICE_WEB_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/user-self-service/user-self-service.component').then((c) => c.UserSelfServiceComponent),
    providers: [provideSelfServiceDomain(), provideAlerting()],
  },
  {
    path: 'kryptohandelfreischaltung',
    loadChildren: () => import('@zero/self-service/feature-crypto-onboarding/web').then((m) => m.CRYPTO_ONBOARDING_WEB_ROUTES),
  },
];
